import React, { useRef, useState  } from 'react';
import { Menu } from "@headlessui/react";

import { ReactComponent as IconChevronDown } from "assets/images/icons/project-icons/chevron-up.svg";


const FilterList = ({options, handleFilterChange}) => {
    const filterListRef = useRef(null)
    const [isOpen, setIsOpen] = useState(false)

    
    const toggleFilter = () => {
        setIsOpen(!isOpen)
    };
    
  return (
    <>
        <Menu as="div" className="relative z-50" ref={filterListRef}>
            <Menu.Button as="div" onClick={toggleFilter} className="h-10 relative flex cursor-pointer rounded hover:bg-gray-100">
                    <button className='flex items-center bg-white px-4 py-2.5' style={{border: "1px solid #D0D5DD", borderRadius: "8px", boxShadow: "0px 1px 2px 0px #1018280D"}}>
                        <span className='pr-2'>Default</span>
                        <IconChevronDown className="m-auto svg-fill-black mb-2 rotate-180" />
                    </button>
            </Menu.Button>
            {isOpen && (
                <Menu.Items as="div" static className="dropdown dropdown-right min-w-[200px] max-w-none top-12">
                    <Menu.Item as="div">
                        <div className='flex flex-col items-start px-4 '>
                            {options?.map(option => (
                               <button onClick={() => {handleFilterChange(option.value); toggleFilter()}} className='font-medium text-left w-full text-ep-gray-300 py-2.5' key={option.name} value={option.value}>{option.name}</button>
                            ))}
                        </div>
                    </Menu.Item>
                </Menu.Items>
            )}
        </Menu>
        {isOpen && <button style={{zIndex: "49"}} className='absolute top-0 right-0 bg-transparent w-full h-full' onClick={() => setIsOpen(false)}></button>}
    </>
        )
}

export default FilterList
